export enum EPrelevementLacType {
    PrelEauIntegre = 1,
    PrelEauPonctuel = 2,
    PrelSediment = 3,
}